// extracted by mini-css-extract-plugin
export default {"legend-item":"legendItem_legend-item__sYyly","color":"legendItem_color__BFRQ1","label":"legendItem_label__WlGW+"};